/* ───────── Kiosk i18n ───────── */

export type Locale = 'sv' | 'en'

const translations = {
  // Attractor
  'attractor.touch': { sv: 'Tryck för att beställa', en: 'Touch to order' },
  'attractor.hint': { sv: 'Tryck var som helst för att börja', en: 'Touch anywhere to start' },

  // Menu type
  'menuType.title': { sv: 'Var vill du äta?', en: 'Where would you like to eat?' },
  'menuType.eatIn': { sv: 'Äta här', en: 'Eat in' },
  'menuType.takeAway': { sv: 'Ta med', en: 'Takeaway' },
  'menuType.back': { sv: 'Tillbaka', en: 'Back' },

  // Product grid
  'grid.all': { sv: 'Alla', en: 'All' },
  'grid.back': { sv: 'Tillbaka', en: 'Back' },

  // Product modal
  'modal.optional': { sv: 'Valfritt', en: 'Optional' },
  'modal.choose': { sv: 'Välj', en: 'Choose' },
  'modal.max': { sv: 'Max', en: 'Max' },
  'modal.required': { sv: 'Obligatorisk', en: 'Required' },
  'modal.add': { sv: 'Lägg till', en: 'Add' },
  'modal.cancel': { sv: 'Avbryt', en: 'Cancel' },

  // Cart
  'cart.title': { sv: 'Varukorg', en: 'Cart' },
  'cart.empty': { sv: 'Varukorgen är tom', en: 'Your cart is empty' },
  'cart.continue': { sv: 'Fortsätt handla', en: 'Continue shopping' },
  'cart.clear': { sv: 'Töm', en: 'Clear' },
  'cart.tip': { sv: 'Dricks', en: 'Tip' },
  'cart.tipAmount': { sv: 'dricks', en: 'tip' },
  'cart.total': { sv: 'Totalt', en: 'Total' },
  'cart.pay': { sv: 'Gå till betalning', en: 'Go to payment' },
  'cart.viewCart': { sv: 'Visa varukorg', en: 'View cart' },

  // Checkout
  'checkout.title': { sv: 'Betala', en: 'Pay' },
  'checkout.back': { sv: 'Tillbaka', en: 'Back' },
  'checkout.order': { sv: 'Din beställning', en: 'Your order' },
  'checkout.payMethod': { sv: 'Välj betalsätt', en: 'Choose payment method' },
  'checkout.card': { sv: 'Kort', en: 'Card' },
  'checkout.swish': { sv: 'Swish', en: 'Swish' },
  'checkout.payBtn': { sv: 'Betala', en: 'Pay' },
  'checkout.processing': { sv: 'Bearbetar...', en: 'Processing...' },
  'checkout.tipLabel': { sv: 'Dricks', en: 'Tip' },
  'checkout.notAvailable': {
    sv: 'Betalningsmetod ej tillgänglig',
    en: 'Payment method not available',
  },

  // Paying
  'paying.swishTitle': { sv: 'Betala med Swish', en: 'Pay with Swish' },
  'paying.swishDesc': {
    sv: 'Skanna QR-koden med Swish-appen',
    en: 'Scan the QR code with the Swish app',
  },
  'paying.cardTitle': { sv: 'Väntar på betalning', en: 'Waiting for payment' },
  'paying.cardDesc': {
    sv: 'Följ instruktionerna på kortterminalen',
    en: 'Follow the instructions on the card reader',
  },
  'paying.cancel': { sv: 'Avbryt', en: 'Cancel' },

  // Receipt
  'receipt.thanks': { sv: 'Tack för din beställning!', en: 'Thank you for your order!' },
  'receipt.eatInMsg': {
    sv: 'Din mat förbereds och serveras snart',
    en: 'Your food is being prepared and will be served soon',
  },
  'receipt.takeAwayMsg': {
    sv: 'Din mat förbereds för avhämtning',
    en: 'Your food is being prepared for pickup',
  },
  'receipt.newOrder': { sv: 'Ny beställning', en: 'New order' },
  'receipt.autoReturn': { sv: 'Återgår automatiskt om', en: 'Returning automatically in' },
  'receipt.seconds': { sv: 'sek', en: 'sec' },

  // Inactivity
  'inactivity.title': { sv: 'Är du fortfarande här?', en: 'Are you still here?' },
  'inactivity.hint': { sv: 'Tryck någonstans för att fortsätta', en: 'Touch anywhere to continue' },

  // Error
  'error.title': { sv: 'Något gick fel', en: 'Something went wrong' },
  'error.retry': { sv: 'Försök igen', en: 'Try again' },
  'error.menuLoad': { sv: 'Kunde inte ladda menyn', en: 'Could not load menu' },

  // Language
  'lang.sv': { sv: 'Svenska', en: 'Svenska' },
  'lang.en': { sv: 'English', en: 'English' },
} as const

type TranslationKey = keyof typeof translations

export function t(key: TranslationKey, locale: Locale): string {
  return translations[key]?.[locale] || translations[key]?.sv || key
}
